import { initializeApp } from 'firebase/app';
import { getFirestore, doc, getDoc, setDoc, updateDoc, addDoc, collection } from 'firebase/firestore';
import { firebaseConfig } from '../components/constants';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

/* In the "words" collection, it searches for the input document ("query").
If not found, returns null.
If found, returns the field given as input ("field").
If the field is found, return its value, otherwise null */
export async function getWordField(query: string, field: string): Promise<any> {
  const wordRef = doc(db, 'words', query);
  try {
    const docSnap = await getDoc(wordRef);
    if (docSnap.exists()) {
      return docSnap.data()[field];
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error getting word field:', error);
  }
}

/**
 * Adds a word to the "words" collection or updates its count if it already exists.
 * @param word The word to add or update in the collection.
 */
export async function addOrUpdateWord(word: string): Promise<void> {
  const wordRef = doc(db, 'words', word);
  try {
    const docSnap = await getDoc(wordRef);
    if (docSnap.exists()) {
      // If the document exists, increase the count
      await updateDoc(wordRef, {
        count: docSnap.data().count + 1
      });
    } else {
      // If the document does not exist, create it with count = 1
      await setDoc(wordRef, { count: 1 });
    }
    //console.log(`Word '${word}' processed successfully.`);
  } catch (error) {
    console.error('Error adding or updating word:', error);
  }
}

/**
 * Adds a set of params to the "functionCallParams" collection or updates its count if it already exists.
 * @param functionName The document name to add or update in the collection, corresponding to the function name.
 * @param params The parameters to add or update in the collection.

 */
export async function logParamsToFirebase(functionName: string, params: object): Promise<void> {
  const paramsRef = doc(db, 'functionCallParams', functionName);
  try {
    const docSnap = await getDoc(paramsRef);
    if (docSnap.exists()) {
      // If the document exists with SAME params, increase the count (if count exists, otherwise set it to 1)
      if (docSnap.data().params === params) {
        await updateDoc(paramsRef, {
          count: docSnap.data().count ? docSnap.data().count + 1 : 1
        });
      } else {
        // If the document exists with DIFFERENT params, update the params and increase the count (if count exists, otherwise set it to 1)
        await updateDoc(paramsRef, {
          count: docSnap.data().count ? docSnap.data().count + 1 : 1,
          params: params
        });
      }

    } else {
      // If the document does not exist, create it with count = 1
      await setDoc(paramsRef, { count: 1, params: params });
    }
    //console.log(`Params for function '${functionName}' processed successfully.`);
  } catch (error) {
    console.error('Error adding or updating params:', error);
  }
  
}



export const submitFeedback = async (email: string, feedback: string): Promise<void> => {
  try {
    await addDoc(collection(db, 'feedback'), {
      email: email,
      feedback: feedback,
      timestamp: new Date() // Optionally track the submission time
    });
    console.log('Feedback submitted successfully');
  } catch (error) {
    console.error('Error submitting feedback: ', error);
    throw new Error('Failed to submit feedback');
  }
};